import styled, { css, keyframes } from "styled-components";

const pulse = keyframes`
  0% { box-shadow: 0 0 0 rgba(0, 0, 0, 0); }
  50% { box-shadow: 0 0 10px rgba(0, 128, 0, 0.4); }
  100% { box-shadow: 0 0 0 rgba(0, 0, 0, 0); }
`;
export const TopWrapper = styled.div`
 
`
export const TotalStudents = styled.span`
  font-weight: 700;
`
export const PausedToggle = styled.button`
  margin-left: 16px;
  padding: 6px 14px;
  border-radius: 999px;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${(p) => (p.$on ? "#7c83fd" : "#ccc")};
  background: ${(p) => (p.$on ? "#7c83fd" : "#fff")};
  color: ${(p) => (p.$on ? "#fff" : "#1E1B3A")};
`
export const PaymentContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  padding: 20px 0;
`;


export const SearchInput = styled.input`
  padding: 10px 15px;
  margin-top: 10px;
  width: 100%;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 25px;
`;

export const StudentPaymentCard = styled.div`
  border-radius: 15px;
  padding: 20px;
  border: 1px solid #eaeaea;
  cursor: pointer;
  transition: 0.3s ease;
  transform: ${({ animate }) => (animate ? "scale(1.02)" : "scale(1)")};
  ${({ animate }) => animate && css`animation: ${pulse} 0.6s ease;`}
  background: ${props => props.isPaused ? '#ffdddd' : '#fff'};
  ${({ colorLevel }) =>
    colorLevel === "low" &&
    css`
      box-shadow: 0 0 10px rgba(255, 0, 0, 0.7);
    `}
  ${({ colorLevel }) =>
    colorLevel === "medium" &&
    css`
      box-shadow: 0 0 10px rgba(255, 165, 0, 0.5);
    `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StudentName = styled.h2`
  font-size: 1.2rem;
  margin: 0;
`;

export const StudentID = styled.p`
  color: #666;
  font-size: 0.9rem;
  margin: 10px 0;
`;

export const MoveItem = styled.span`
  font-size: 12px;
  color: #555;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
`;

export const ProgressBar = styled.progress`
  width: 100%;
  height: 10px;
  appearance: none;

  &::-webkit-progress-bar {
    background-color: #f0f0f0;
    border-radius: 10px;
  }

  &::-webkit-progress-value {
    background-color: #4caf50;
    border-radius: 10px;
  }
`;

export const Actions = styled.div`
  margin: 10px 0;
  display: flex;
  gap: 10px;
`;

export const ChangeButton = styled.button`
  padding: 5px 10px;
  font-size: 0.9rem;
  background-color: #f3f3f3;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #e0e0e0;
  }
`;

export const PackagesList = styled.div`
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const PackageButton = styled.button`
  padding: 6px 12px;
  background-color: #a09eff;
  border: none;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background-color: #8985f8;
  }
`;

export const SuccessText = styled.p`
  color: green;
  font-size: 0.85rem;
  margin-top: 10px;
`;

export const ErrorText = styled.p`
  color: red;
  font-size: 0.85rem;
  margin-top: 10px;
`;

export const ConfirmBox = styled.div`
  margin-top: 12px;
  padding: 12px;
  border-radius: 12px;
  background: #f4f3ff;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 0.9rem;

  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-weight: 600;
  }
`;

export const AmountInput = styled.input`
  padding: 6px 10px;
  border: 1px solid #c9c6f5;
  border-radius: 8px;
  font-size: 1rem;
  max-width: 160px;
`;

export const ConfirmActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
